import React from "react";
import { Mutation } from "react-apollo";

import Form from "../components/form";
import {
  EDIT_AD_UNIT,
  FIND_ADUNITS_BY_PLUBLISHERID,
  FIND_ADUNITS_DOMAINS,
} from "../../../queries/adUnit";

const Update = props => {
  const publisherId = props.publisherId;
  return (
    <Mutation
      mutation={EDIT_AD_UNIT}
      refetchQueries={[
        { query: FIND_ADUNITS_DOMAINS },
        { query: FIND_ADUNITS_BY_PLUBLISHERID, variables: { publisherId } },
      ]}
      awaitRefetchQueries={true}
    >
      {updateAdUnit => <Form query_f={updateAdUnit} {...props} />}
    </Mutation>
  );
};

export default Update;
